import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResult } from '@app/soco/core';
import { SocoHttpService } from '@app/soco/http';

@Injectable()
export class LocationService {
  public stateLatLng: any;

  constructor(private http: SocoHttpService) { }

  isLocationServicableById(location: any): Observable<ApiResult<IsServicable>> {
    return this.http.get<IsServicable>({
      url: 'externalService/GetServiceAvailability',
      params: location,
      shouldIgnoreInvalidResult: false,
      pleaseWaitTimeoutDuration: 500,
      pleaseWaitMessage: 'Processing.',
      pleaseWaitContainerId: 'ContainerAwaiter'
    });
  }
}

export interface IsServicable {
  isServicable: string;
  serviceCenter: string;
  localDistrict: string;
  localDistrictCd: string;
  county: string;
  xCoordinate: number;
  yCoordinate: number;
}
